import React from 'react'

const DocumentIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="documentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(180, 140, 255, 1)" />
          <stop offset="100%" stopColor="rgba(140, 100, 220, 1)" />
        </linearGradient>
        <filter id="documentGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Document shape */}
      <path 
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
        fill="url(#documentGradient)"
        filter="url(#documentGlow)"
      />
      
      {/* Folded corner */}
      <path 
        d="M14 2v6h6"
        stroke="rgba(255, 255, 255, 0.5)"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Text lines */}
      <line 
        x1="8" 
        y1="13" 
        x2="16" 
        y2="13" 
        stroke="rgba(255, 255, 255, 0.8)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line 
        x1="8" 
        y1="17" 
        x2="13" 
        y2="17" 
        stroke="rgba(255, 255, 255, 0.8)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default DocumentIcon
